// Client-side feature flags, sourced from localStorage so testers can
// opt in without a redeploy. Default for every flag is OFF — these are
// not "settings" to be configured by end users; they are temporary
// rollout switches that flip ON once we've validated a change in deploy.
//
// Flip a flag from the browser console:
//   localStorage.setItem('aos-collab-coedit', 'true')
//   location.reload()
//
// Flags should be short-lived. When the gated behavior becomes the
// default for everyone, delete the flag check rather than letting the
// switch linger as a permanent affordance.

const BLUEPRINT_COLLAB_COEDIT_KEY = 'aos-collab-coedit'

// isBlueprintCollabCoeditEnabled gates the live Yjs co-editing path in the
// BlueprintEditor. When ON, the editor connects to the <orgId>:<slug>:blueprint
// room on character open, hydrates from the synced Y.Doc, and routes edits
// through the collab client (no localStorage authority). When OFF, the editor
// uses today's localStorage-first boot + ~600ms autosave + explicit cloud load.
// Testers opt in with localStorage 'aos-collab-coedit' = 'true'.
// Delete this flag once co-editing is validated and shipped.
export function isBlueprintCollabCoeditEnabled() {
  if (typeof window === 'undefined') return false
  try {
    return window.localStorage.getItem(BLUEPRINT_COLLAB_COEDIT_KEY) === 'true'
  } catch {
    return false
  }
}

const ORG_ENVIRONMENTS_KEY = 'aos-org-environments'

// isOrgEnvironmentsEnabled gates the org-scoped environment asset UI. Org
// environments are now the ONLY model (the per-character path was removed), so
// this defaults ON — the Environments panel is visible without any opt-in.
// A localStorage kill-switch ('aos-org-environments' = 'false') can force it off
// during the rollout window. Delete this flag once the org AAM endpoints are
// deployed to every environment the web runs against.
export function isOrgEnvironmentsEnabled() {
  if (typeof window === 'undefined') return true
  try {
    return window.localStorage.getItem(ORG_ENVIRONMENTS_KEY) !== 'false'
  } catch {
    return true
  }
}
